import React from 'react';
import '../FadeIn.css';

interface FadeInProps {
    children: React.ReactNode;
    duration?: number;
    delay?: number;
}

export default function FadeIn({ children, duration = 1000, delay = 0 }: FadeInProps) {
    const [isVisible, setIsVisible] = React.useState(false);

    React.useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, delay);
        return () => clearTimeout(timer);
    }, [delay]);

    return (
        <div className={`fade-in ${isVisible ? 'show' : ''}`} style={{ transitionDuration: `${duration}ms` }}>{children}</div>
    );
}